import { haptic } from '../lib/haptics.js';

/**
 * Moderator-only: who is asking to come on stage.
 *
 * Promotion is the product's sharpest moment — it changes what another person
 * is allowed to do, live — so the action is named for what it does to them
 * ("Bring on stage"), not for the API call underneath.
 */
export function HandQueue({
  hands,
  onPromote,
  onDismiss,
  busy,
}: {
  /* Name for the human, subject for the action — never the other way round. */
  hands: Array<{ sub: string; name: string }>;
  onPromote: (sub: string) => void;
  onDismiss: (sub: string) => void;
  busy: string | null;
}) {
  if (!hands.length) {
    return <p class="t-foot">No one is waiting.</p>;
  }

  return (
    <ul class="queue">
      {hands.map((hand) => (
        <li key={hand.sub} class="queue__row">
          <span class="queue__hand" aria-hidden="true">
            ✋
          </span>
          <span class="queue__name" title={hand.name}>
            {hand.name}
          </span>
          <button
            class="primary"
            disabled={busy === hand.sub}
            onClick={() => {
              haptic('press');
              onPromote(hand.sub);
            }}
          >
            {busy === hand.sub ? 'Bringing up…' : 'Bring on stage'}
          </button>
          <button
            disabled={busy === hand.sub}
            onClick={() => {
              haptic('tick');
              onDismiss(hand.sub);
            }}
          >
            Not now
          </button>
        </li>
      ))}
    </ul>
  );
}
